import React from "react";
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "./style.scss";

export enum GridButtonType {
  "edit",
  "default",
}
interface TableButtonProps {
  icon?: any;
  title?: string;
  type: GridButtonType;
  onClick: (e: any) => void;
}
const ReponsiveTable = ({
  bordered,
  data,
  columns,
  buttons,
}: {
  bordered?: boolean;
  columns: {
    dataField: string;
    caption: string;
    formatter?: (value: any, data?: any) => void;
    lookup?: {
      data: any[];
      key: string;
      labelkey: string;
    };
  }[];
  buttons?: TableButtonProps[];
  data: any[];
}) => {
  return (
    <React.Fragment>
      <Table className={"borderedTable"}>
        <Thead>
          <Tr>
            {columns.map((x, i) => (
              <Th key={i}>{x.caption}</Th>
            ))}
            {buttons && <Th></Th>}
          </Tr>
        </Thead>
        <Tbody>
          {data.map((x, i) => (
            <Tr key={i}>
              {columns.map((y, i) => {
                if (y.lookup) {
                  const value = y.lookup.data.find(
                    (a) => a[y.lookup ? y.lookup.key : "Id"] === x[y.dataField]
                  );
                  return (
                    <Td key={i}>{value ? value[y.lookup.labelkey] : "-"}</Td>
                  );
                } else {
                  return (
                    <Td key={i}>
                      {y.formatter
                        ? y.formatter(x[y.dataField])
                        : x[y.dataField]}
                    </Td>
                  );
                }
              })}
              {buttons && (
                <Td style={{ maxWidth: 50 }}>
                  <div className="gridColumnButtonContainer">
                    {buttons.map((a, i) => (
                      <button
                        key={i}
                        className="gridButtonItem"
                        onClick={() => {
                          return a.onClick(x);
                        }}
                      >
                        {a.icon && <i className={a.icon} />}
                        {a.title && a.title}
                      </button>
                    ))}
                  </div>
                </Td>
              )}
            </Tr>
          ))}
        </Tbody>
      </Table>
    </React.Fragment>
  );
};
export default ReponsiveTable;
